export enum OS {
  Mac = 'mac',
  Win = 'win',
  Linux = 'linux',
}

export type DesktopOS = 'mac' | 'win' | 'linux';

export function getDesktopOS(): DesktopOS | undefined {
  const { userAgent, platform } = navigator;

  if (/Mac/.test(platform)) return OS.Mac;
  if (/Win/.test(platform)) return OS.Win;
  if (/Linux/.test(platform)) {
    // Some Android devices have Linux substring in navigator.platform
    if (/Android/.test(userAgent)) return undefined;

    return OS.Linux;
  }

  return undefined;
}
